import {AccountManager} from "@nuskin/ns-account";
import {PersonalOfferStorageService,events} from "@nuskin/ns-util";
import {AdrService, CartService, OrderManager, PersonalOfferService } from "@nuskin/ns-shop";
import CheckoutModeService from './checkoutModeService';

export default {
    cleanupOrder
};

const EXTERNAL_PAYMENT_NEXT_ORDER = "externalPaymentNextOrder";


// ======================================================================================
//       PUBLIC FUNCTIONS
// ======================================================================================

function cleanupOrder() {
    let order = OrderManager.getCompletedOrder(),
        adr = AdrService.getAdrDraft(),
        nextOrder = OrderManager.getOrder();

    OrderManager.removeCompletedOrders();

    // Update the cart cookie in case we leave the page
    // but keep the same cart in the order so we can display it.
    if (CartService.getCartProperty('summerPromo')) {
        localStorage.removeItem("summerPromoCart");
        localStorage.removeItem("shoppingCart");
    }

    // if storefront or pitch they will have a sponsor
    if (CheckoutModeService.isGuestCheckout()) {
        AccountManager.softLogout();
    }
    if (!nextOrder) {
        _cleanupPersonalOfferCheckout();
    }
    if (order.adr && adr.shipImmediate) {
        CartService.removeItems({all: true, removeCart: !nextOrder});
    } else if (order.adr) {
        CartService.removeItems({cartAdrItems: true, sapAdrItems: true, removeCart: !nextOrder});
    } else {
        CartService.removeItems({cartOrderItems: true, sapOrderItems: true, removeCart: !nextOrder});
    }
    // First order for this user has been placed now cleanup the cart
    CartService.setCartProperties({summerPromo: false, inSignup: false});

    // Clear Loyalty points
    CartService.clearLoyaltyPoints();

    // Update loyalty header
    events.publish(events.loyalty.UPDATE_LOYALTY_DATA);


    // If there are more orders update the cart in the rest of the orders
    if (nextOrder) {
        //for next order we want to ignore the query parameter this sets the flag
        localStorage.setItem(EXTERNAL_PAYMENT_NEXT_ORDER, 'true');
        OrderManager.saveOrders();
    } else {
        // No more orders.  Delete the adr cookie
        AdrService.clearLocalData();

    }

    let minicart = document.getElementById("ns-cart");
    if (minicart) {
        minicart.setAttribute("cart-count", "");
    }
}

// ======================================================================================
//       PRIVATE FUNCTIONS
// ======================================================================================

function _cleanupPersonalOfferCheckout() {
    let personalOffer = PersonalOfferStorageService.getPersonalOffer(),
        personalOfferLanding;

    if (personalOffer) {
        personalOfferLanding = personalOffer.landingPageURL;
        PersonalOfferService.callComplete(personalOffer.sapId, personalOffer.pitchID);
    }

    PersonalOfferStorageService.clearPersonalOffer();
    // SponsorStorageService.clearSponsor();
    const miniCart = document.getElementsByTagName("ns-mini-cart")[0]
    const homeLink = document.getElementById("homeLink")
    if (personalOfferLanding) {
        if(miniCart) miniCart.setAttribute("href", personalOfferLanding);
        if(homeLink) homeLink.setAttribute("href", personalOfferLanding);
    }

}
